import axios from 'axios';

const API_BASE_URL = 'https://twiqli-server-vercel.vercel.app/api';

export const createRestaurant = async (data) => {
  const token = localStorage.getItem('ownerToken');

  const response = await axios.post(
    `${API_BASE_URL}/restaurants/create`,
    data,
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

// export const createRestaurant = async (restaurantData) => {
//     const formData = new FormData();
//     formData.append('name', restaurantData.name);
//     formData.append('address', restaurantData.address);
//     formData.append('description', restaurantData.description);
//     formData.append('profileImage', restaurantData.profileImage);

//     const response = await api.post('/restaurants', formData);
//     return response.data;
//   };

// const token = localStorage.getItem('ownerToken');
// const response = await api.get(`/restaurants/${restaurantId}/messages`, {
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// });

export const getQRCode = async (restaurantId) => {
  const token = localStorage.getItem('ownerToken');

  const response = await axios.get(
    `${API_BASE_URL}/restaurants/${restaurantId}/qr-code`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const listRestaurants = async (token) => {
  const response = await axios.get(`${API_BASE_URL}/restaurants`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const getOwnerRestaurants = async (token) => {
  const response = await axios.get(`${API_BASE_URL}/restaurants`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const subscribeToRestaurant = async (restaurantId, token) => {
  const response = await axios.post(
    `${API_BASE_URL}/customers/subscribe/${restaurantId}`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    }
  );
  return response.data;
};

export const getRestaurant = (restaurantId) => {
  const token = localStorage.getItem('ownerToken');

  return axios.get(`${API_BASE_URL}/restaurants/${restaurantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const fetchRestaurantUnsubscribeLink = async (restaurantId) => {
  const token = localStorage.getItem('ownerToken');

  return axios.get(
    `${API_BASE_URL}/restaurants/${restaurantId}/unsubscribe-link`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
};

// const token = localStorage.getItem('ownerToken');
// const response = await api.get(`/restaurants/${restaurantId}/messages`, {
//   headers: {
//     Authorization: `Bearer ${token}`,
//   },
// });

export const updateRestaurant = (restaurantId, updates) => {
  const token = localStorage.getItem('ownerToken');

  return axios.put(`${API_BASE_URL}/restaurants/${restaurantId}`, updates, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const deleteRestaurant = (restaurantId) => {
  const token = localStorage.getItem('ownerToken');

  return axios.delete(`${API_BASE_URL}/restaurants/${restaurantId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};
